import { FulfillmentBatch } from "./useFulfillmentBatch";
import { useRouteLoaderData } from "react-router-dom";

export interface TestWarehouse {
  id: number;
  name: string;
}

export interface CurrentUser {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  permissions: any;
  warehouseId: number | null;
  warehouseName: string;
  warehouseTimezone: string | null;
  canSelectWarehouse: boolean;
  warehouses: TestWarehouse[];
  email: string;
  currentFulfillmentBatch: FulfillmentBatch | null;
}

export default function useCurrentUser() {
  const { user } = useRouteLoaderData("global") as { user: CurrentUser };
  return {
    user,
    currentUserPermissions: user.permissions,
  };
}
